'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useAuthStore } from '@/stores/authStore';
import { PageLoader } from '@/components/ui/Loaders';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const access = useAuthStore((s) => s.access);
  const router = useRouter();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = access ?? localStorage.getItem('access');
    if (!token) {
      const returnTo =
        typeof window !== 'undefined'
          ? encodeURIComponent(window.location.pathname + window.location.search)
          : '';
      router.replace(returnTo ? `/login?redirect=${returnTo}` : '/login');
    } else {
      setChecked(true);
    }
  }, [access, router]);

  if (!checked) {
    return <PageLoader message="Checking authentication..." />;
  }

  return <>{children}</>;
}
